import { create } from 'zustand';
import Instance from '../Utils/Axios';

const useDashboardStore = create((set, get) => ({
  packageData: null,
  activePackageCount: 0,
  notificationData: [],
  notificationUnreadCount: 0,
  loading: false,
  error: null,
  fetchPromise: null,

  fetchDashboardData: async (background = false, force = false) => {
    if (get().fetchPromise && !background) {
      return get().fetchPromise;
    }

    if (!force && get().packageData && !get().error) {
      return Promise.resolve(get().packageData);
    }

    const promise = (async () => {
      if (!background) set({ loading: true, error: null });
      try {
        const res = await Instance.post("/user/dashboard", {});
        const packageData = res.data?.message?.package || null;
        const activeCount = packageData?.activePackageCount || 0;
        const notificationData = res.data?.message?.pressRelease?.notification || [];
        const notificationUnreadCount = res.data?.message?.pressRelease?.notificationUnreadCount || 0;
        
        set({ 
          packageData, 
          activePackageCount: activeCount,
          notificationData,
          notificationUnreadCount,
          loading: false,
          fetchPromise: null 
        });
        return packageData;
      } catch (err) {
        let errorMsg = err.response?.data?.resMessage || err.response?.data?.message;
        if (typeof errorMsg === 'object') {
          errorMsg = errorMsg.resMessage || errorMsg.message || JSON.stringify(errorMsg);
        }
        set({ 
          error: errorMsg, 
          loading: false,
          fetchPromise: null 
        });
        throw err;
      }
    })();

    if (!background) set({ fetchPromise: promise });
    return promise;
  },


  markAsRead: async (id) => {
    const { notificationData, notificationUnreadCount } = get();
    
    const targetNotif = notificationData.find(n => n.id === id);
    if (targetNotif && targetNotif.read === 0) {
      
      const updatedData = notificationData.map(n => {
        if (n.id === id) {
          return { 
            ...n, 
            read: 1, 
            readOn: new Date().toLocaleString('en-US', { hour12: false }).replace(',', '')
          };
        }
        return n;
      });
      
      set({ 
        notificationData: updatedData,
        notificationUnreadCount: Math.max(0, notificationUnreadCount - 1)
      });

      try {
        await Instance.post("/user/notification/read", { id });
      } catch (err) {
        console.error("Failed to mark notification as read on backend", err);
      }
    }
  },

  setPackageData: (data) => set({ packageData: data }),
  setNotificationData: (data) => set({ notificationData: data }),
  setError: (error) => set({ error }),
  resetDashboardData: () => set({ packageData: null, activePackageCount: 0, notificationData: [], notificationUnreadCount: 0, error: null, fetchPromise: null }),
}));

export default useDashboardStore;

